import React from 'react';
import { WorkflowProps } from '@/types/workflow';
import { WeaveButton } from '@/components/UI/WeaveButton/WeaveButton';
import { newModal } from '@/components/UI/WeaveModal/WeaveModal';
import { ExportPdfModalContent } from '@/components/Analysis/BioScore/ExportPdfModalContent';
import { PersistedExportAssets } from '@/services/export/reportDataBuilder';
import { useWorkflowStore } from '@/store/workflowStore';
import styles from './assessmentStyles.module.scss';

type AssessmentExportState = {
	assets?: PersistedExportAssets;
};

const AssessmentComplete: React.FC<WorkflowProps> = ({
	workflowData,
	currentStage,
}) => {
	const setWorkflowData = useWorkflowStore((state) => state.setWorkflowData);
	const exportState = (workflowData[6]?.data as AssessmentExportState | undefined) ?? {};

	return (
		<div>
			<div className={styles.exportContainer}>
				<h2 className={styles.exportHeader}>Export results</h2>
				<p>
					Generate a stage-aware PDF snapshot of the current BioScore workflow state,
					including available room/function data, breakdowns and optional analysis images.
				</p>
				<WeaveButton
					density="medium"
					variant="solid"
					className={styles.exportButton}
					onClick={() =>
						newModal({
							title: 'Export BioScore Report',
							width: '760px',
							content: (
								<ExportPdfModalContent
									workflowData={workflowData}
									currentStage={currentStage ?? 'predesign_programming'}
									initialAssets={exportState.assets}
									onAssetsChange={(assets) =>
										setWorkflowData(6, {
											data: {
												...exportState,
												assets,
											},
										})
									}
								/>
							),
						})
					}
				>
					Export PDF
				</WeaveButton>
			</div>
		</div>
	);
};

export default AssessmentComplete;
